import { render, staticRenderFns } from "./PassportLayout.vue?vue&type=template&id=8b933ece&scoped=true&"
import script from "./PassportLayout.vue?vue&type=script&lang=js&"
export * from "./PassportLayout.vue?vue&type=script&lang=js&"
import style0 from "./PassportLayout.vue?vue&type=style&index=0&id=8b933ece&lang=scss&scoped=true&"
import style1 from "./PassportLayout.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b933ece",
  null
  
)

export default component.exports